import React from 'react';
import { Star } from 'lucide-react';
export const HeroSection = () => {
  const scrollToPricing = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-16 pb-20 px-4 md:pt-24 md:pb-32 max-w-5xl mx-auto text-center" data-id="element-92">
      <div className="mb-6" data-id="element-93">
        <p className="text-gold-light font-outfit text-sm md:text-base uppercase tracking-widest mb-4" data-id="element-94">
          Para mujeres que sienten el llamado de la brujería
        </p>
        <h1 className="font-cormorant text-5xl md:text-7xl lg:text-8xl text-gold-primary mb-2 font-light" data-id="element-95">
          Grimorio <span className="font-medium text-gold-light" data-id="element-96">del Sur</span>
        </h1>
        <p className="font-cormorant italic text-text-soft text-2xl md:text-3xl mt-4" data-id="element-97">
          De la curiosidad a tu primer ritual
        </p>
      </div>

      <div className="relative max-w-2xl mx-auto my-12 cursor-pointer group" onClick={scrollToPricing} data-id="element-98">
        <div className="absolute inset-0 gold-glow-shadow rounded-xl opacity-50 group-hover:opacity-100 transition-opacity duration-500" data-id="element-99"></div>
        <img src="https://cdn.magicpatterns.com/uploads/iH3orWQ3vDpToN2x2gqcRy/Diseno_sin_titulo_(71).jpg" alt="Grimorio del Sur y Bonus" className="relative z-10 w-full rounded-xl border border-gold-dark/30 shadow-2xl transform group-hover:scale-[1.02] transition-transform duration-500" data-id="element-100" />
      </div>

      <div className="max-w-2xl mx-auto space-y-6" data-id="element-101">
        <h2 className="text-2xl md:text-3xl font-outfit font-medium text-text-primary" data-id="element-102">
          Tu primer ritual en 7 días, <br className="hidden md:block" data-id="element-103" />
          <span className="text-gold-light" data-id="element-104">
            sin necesitar experiencia previa.
          </span>
        </h2>

        <p className="text-text-soft text-lg md:text-xl" data-id="element-105">
          Sin gastar en herramientas que no tenés. Sin sentir que lo estás
          haciendo mal.
        </p>

        <div className="flex items-center justify-center gap-2 text-gold-primary my-8" data-id="element-106">
          <div className="flex" data-id="element-107">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-108" />)}
          </div>
          <span className="text-text-primary font-medium ml-2" data-id="element-109">4.9/5</span>
          <span className="text-text-muted mx-2" data-id="element-110">|</span>
          <span className="text-text-soft" data-id="element-111">+300 mujeres ya lo usan</span>
        </div>

        <button onClick={scrollToPricing} className="btn-gold w-full md:w-auto px-8 py-4 rounded-full text-lg font-bold uppercase tracking-wide shadow-lg" data-id="element-112">
          QUIERO MI GRIMORIO AHORA
        </button>

        <p className="text-text-muted text-sm mt-4 flex items-center justify-center gap-2" data-id="element-113">
          <span data-id="element-114">Compra 100% segura</span>
          <span data-id="element-115">|</span>
          <span data-id="element-116">Acceso inmediato por mail</span>
        </p>
      </div>
    </section>;
};